export function democraticBandLabel(score: number): string {
  if (score >= 70) return 'alert 70+';
  if (score >= 60) return 'zvysene 60-69';
  if (score >= 50) return 'watch 50-59';
  if (score >= 25) return 'nizke 25-49';
  return 'zanedbatelne 0-24';
}
